(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcf-cart-page"]) return;
  try {
    
(function(){
  document.addEventListener('click', function(e){
    const removeBtn = e.target.closest('[data-lcf-cart-remove]');
    if (!removeBtn) return;
    const line = removeBtn.closest('[data-lcf-cart-line]');
    if (!line) return;
    e.preventDefault();
    const key = line.dataset.lineKey;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(){ window.location.reload(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcf-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-lcf-collection-chips]').forEach(function(chips){
    const section = chips.closest('section');
    const grid = section.querySelector('[data-lcf-collection-grid]');
    const empty = section.querySelector('[data-lcf-collection-empty]');
    if (!grid) return;

    chips.addEventListener('click', function(e){
      const btn = e.target.closest('[data-lcf-filter-value]');
      if (!btn) return;
      const value = (btn.dataset.lcfFilterValue || '').trim().toLowerCase();
      chips.querySelectorAll('[data-lcf-filter-value]').forEach(function(b){
        b.classList.toggle('is-active', b === btn);
      });
      const cards = grid.querySelectorAll('[data-lcf-product-tags]');
      let visible = 0;
      cards.forEach(function(card){
        const tags = (card.dataset.lcfProductTags || '').split(',').map(function(t){ return t.trim(); });
        const ptype = (card.dataset.lcfProductType || '').trim();
        const match = !value || tags.indexOf(value) !== -1 || ptype === value;
        card.classList.toggle('is-hidden', !match);
        if (match) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcf-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-lcf-gallery-section]').forEach(function(section){
    const grid = section.querySelector('[data-lcf-gallery]');
    const tabs = section.querySelectorAll('[data-lcf-tab-id]');
    const empty = section.querySelector('[data-lcf-gallery-empty]');
    const lightbox = section.querySelector('[data-lcf-lightbox]');
    const stage = section.querySelector('[data-lcf-lightbox-stage]');
    const closeBtn = section.querySelector('[data-lcf-lightbox-close]');
    if (!grid) return;

    function applyFilter(category){
      if (!category) return;
      const items = grid.querySelectorAll('[data-lcf-photo-category]');
      let visible = 0;
      items.forEach(function(item){
        const match = item.dataset.lcfPhotoCategory === category;
        item.classList.toggle('is-hidden', !match);
        if (match) visible++;
      });
      if (empty) empty.hidden = visible !== 0 || items.length === 0;
      tabs.forEach(function(t){
        t.setAttribute('aria-selected', t.dataset.lcfTabId === category ? 'true' : 'false');
      });
    }

    if (tabs.length){
      const initial = (window.location.hash || '').replace('#', '') || section.dataset.defaultTab;
      const validIds = Array.from(tabs).map(function(t){ return t.dataset.lcfTabId; });
      const startTab = validIds.indexOf(initial) !== -1 ? initial : (section.dataset.defaultTab || validIds[0]);
      applyFilter(startTab);

      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          const id = tab.dataset.lcfTabId;
          applyFilter(id);
          history.replaceState(null, '', '#' + id);
        });
      });

      window.addEventListener('hashchange', function(){
        const next = (window.location.hash || '').replace('#', '');
        if (validIds.indexOf(next) !== -1) applyFilter(next);
      });
    }

    function open(src, caption){
      if (!lightbox || !stage) return;
      stage.innerHTML = '';
      const img = document.createElement('img');
      img.src = src;
      img.alt = caption || '';
      stage.appendChild(img);
      if (caption) {
        const p = document.createElement('p');
        p.className = 'lcf-lightbox__caption';
        p.textContent = caption;
        stage.appendChild(p);
      }
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function close(){
      if (!lightbox || !stage) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      stage.innerHTML = '';
    }

    grid.querySelectorAll('[data-lcf-gallery-open]').forEach(function(btn){
      btn.addEventListener('click', function(){ open(btn.dataset.src, btn.dataset.caption); });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (lightbox) lightbox.addEventListener('click', function(e){ if (e.target === lightbox) close(); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcf-header"]) return;
  try {
    
(function(){
  const header = document.querySelector('[data-lcf-header]');
  if (!header) return;

  function onScroll(){
    if (window.scrollY > 60) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const toggles = header.querySelectorAll('[data-lcf-nav-toggle]');
  toggles.forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      toggles.forEach(function(other){
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          const otherMenu = document.getElementById(other.getAttribute('aria-controls'));
          if (otherMenu) otherMenu.hidden = true;
        }
      });
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (menu) menu.hidden = expanded;
    });
  });

  document.addEventListener('click', function(e){
    if (header.contains(e.target)) return;
    toggles.forEach(function(btn){
      btn.setAttribute('aria-expanded', 'false');
      const menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (menu) menu.hidden = true;
    });
  });

  const mobileBtn = header.querySelector('[data-lcf-mobile-toggle]');
  const mobileDrawer = header.querySelector('[data-lcf-mobile-drawer]');
  if (mobileBtn && mobileDrawer) {
    mobileBtn.addEventListener('click', function(){
      const isOpen = mobileDrawer.classList.toggle('is-open');
      mobileBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileDrawer.hidden = !isOpen;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcf-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-lcf-pdp]').forEach(function(section){
    const mainImg = section.querySelector('.lcf-pdp__media-main img');
    section.querySelectorAll('[data-lcf-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        const src = thumb.dataset.src;
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.removeAttribute('srcset');
        }
        section.querySelectorAll('[data-lcf-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    const qtyInput = section.querySelector('.lcf-qty__input');
    section.querySelectorAll('[data-lcf-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (!qtyInput) return;
        const step = parseInt(btn.dataset.lcfQtyStep, 10) || 1;
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
